import { createFileRoute, Link } from '@tanstack/react-router'
import { Button, Result } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute('/verified')({
    component: VerifyComponent,
})

function VerifyComponent() {
    const { t } = useTranslation()

    return (
        <Result
            className="my-24"
            title={t('Your email address has been verified')}
            subTitle={t('Thank you for register')}
            status="success"
            extra={
                <Link to="/dashboard">
                    <Button
                        size="large"
                        type="primary"
                    >
                        {t('To dashboard')}
                    </Button>
                </Link>
            }
        />
    )
}
